export default __webpack_public_path__ + "static/media/Tinda.bf365aa7.jpg";